import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, Drawer, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ViewDate from "../../../Components/Masters/ViewDate";
import { truncateNumber } from "../../../utils/common";

function ViewEmployeeCommute({
  title,
  inputData,
  data,
  viewData,
  setViewData,
}) {
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (data) {
      console.log(data, "dataFROVIEWROAD");
      setFilteredData(data);
    }
  }, [data]);

  const getMonth = (dateStr) => {
    const date = new Date(dateStr);

    return date.toLocaleString("default", { month: "short", year: "numeric" });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "410px",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={() => setViewData(false)} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          View {title}
        </Typography>

        <Grid container spacing={2}>
          <ViewDate data={data} />
          {inputData.map((input) => {
            const value = filteredData?.[input.fieldName];
            console.log(value, input.fieldName, "dataForView");
            if (value === undefined || value === null) return null;

            let displayValue;
            displayValue =
              input.fieldName === "month"
                ? getMonth(value)
                : input.fieldName === "averageDistanceOneWay"
                ? truncateNumber(value) || "-"
                : typeof value === "object" && value !== null
                ? value.value ||
                  value.logisticVendorLegalName ||
                  value.driverName ||
                  value.vehicleType
                : value || "-";

            return (
              <Grid item xs={12} sm={12} key={input.fieldName}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {input.title}
                </Typography>
                <div>
                  {Array.isArray(input.options)
                    ? input.options.includes(displayValue)
                      ? displayValue
                      : "-"
                    : displayValue ?? "-"}
                </div>
              </Grid>
            );
          })}
        </Grid>

        {/* <Button
          variant="contained"
          sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
          onClick={handleEdit}
        >
          Edit
        </Button> */}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => setViewData(false)}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewEmployeeCommute;
